module.exports = __webpack_public_path__ + "img/sbh2.75497580.jpg";